module.exports = __webpack_public_path__ + "assets/img/team_pic.450dce84.png";